module.exports = __webpack_public_path__ + "img/techelevator.c7ad0b19.png";